import { TabState } from '@interfaces/vendor-management-model';

export const columnDefs = [
  {
    field: 'managerName',
    headerName: 'Managers',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'totalContractors',
    headerName: 'Count',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'Hyderabad',
    headerName: 'HYD',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
   },
  {
    field: 'NCR',
    headerName: 'NCR',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'Remote',
    headerName: 'Remote',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
];

export const tabsData: TabState[] = [
  {
    label: 'Org View',
    isTabActive: true,
    value: 'Org View',
    activeTab: true,
  },
  {
    label: 'Manager View',
    isTabActive: false,
    value: 'Manager View',
    activeTab: false,
  },
];

export const StaticTexts = {
  ErrorMessages: {
    NoDataAvailable: 'No data available',
    FailedToFetchManagerData: 'Failed to fetch manager data.',
  },
  Alerts: {
    EmployeeIdNotFound: 'Employee ID not found.',
  },
  Labels: {
    NoDataImageAlt: 'No data found',
  },
};
